import { tv } from "tailwind-variants";

export const UILabel = tv({
    slots: {
        base: "tw:relative tw:w-fit tw:font-bold tw:flex tw:group/label",
        entry: "tw:block tw:bg-danger tw:text-white tw:px-1.5 tw:py-0.5"
    },
    variants: {
        position: {
            left: {
                base: "tw:flex-row",
                entry: "tw:group-[*]/label:last:rounded-r-sm"
            },
            right: {
                base: "tw:flex-row-reverse",
                entry: "tw:group-[*]/label:last:rounded-l-sm"
            }
        },
        variant: {
            primary: { entry: "" },
            secondary: { entry: "tw:bg-yellow tw:text-danger" }
        },
        type: {
            label: { base: "", entry: "" },
            ribbon: {
                base: [
                    "tw:before:content-[''] tw:before:absolute tw:before:h-0 tw:before:-bottom-1.5 tw:before:border-y-6 tw:before:border-y-transparent",
                    "tw:after:content-[''] tw:after:absolute tw:after:h-full tw:after:w-2 tw:after:bg-danger"
                ],
                entry: ""
            }
        },
        size: {
            xs: { base: "tw:text-[10px]", entry: "" },
            sm: { base: "tw:text-xs", entry: "" },
            md: { base: "", entry: "" },
            lg: { base: "tw:text-xl", entry: "" },
            xl: { base: "", entry: "" }
        }
    },
    compoundVariants: [
        {
            type: "ribbon",
            position: "left",
            class: {
                base: [
                    "tw:before:-left-1.5 tw:before:border-r-6 tw:before:border-r-danger-focus",
                    "tw:after:-left-1.5"
                ]
            }
        },
        {
            type: "ribbon",
            position: "right",
            class: {
                base: [
                    "tw:before:-right-1.5 tw:before:border-l-6 tw:before:border-l-danger-focus",
                    "tw:after:-right-1.5"
                ]
            }
        },
        {
            type: "label",
            position: "left",
            class: { entry: "tw:group-[*]/label:first:rounded-l-sm" }
        },
        {
            type: "label",
            position: "right",
            class: { entry: "tw:group-[*]/label:first:rounded-r-sm" }
        }
    ],
    defaultVariants: {
        size: "md",
        variant: "primary"
    }
});
